"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _interactionTypes = require("crm_ui/components/profile/interactions/config/interactionTypes");

var interactions = [_interactionTypes.NOTE, _interactionTypes.EMAIL, _interactionTypes.CALL, _interactionTypes.LOGGED_CALL, _interactionTypes.LOGGED_MEETING, _interactionTypes.TASK, _interactionTypes.SCHEDULE, _interactionTypes.LOGGED_EMAIL, _interactionTypes.EMAIL_REPLY];
var InteractionTypesConfig = (0, _immutable.Seq)(interactions);
var _default = InteractionTypesConfig;
exports.default = _default;
module.exports = exports.default;